document.addEventListener('DOMContentLoaded', () => {
  $('.cp-add-cta').hide()
  if ($('#cp-type-list').val() == 'reference') {
    $('.cp-cta-icon').show()
    $('.cp-cta-icon-data').show()
    $('.cp-cta-cover').show()
    $('.cp-cta-cover-data').show()
    $('.cp-cta-link').show()
    $('.cp-cta-link-data').show()
  } else {
    $('.cp-cta-icon').hide()
    $('.cp-cta-icon-data').hide()
    if ($('.cp-cta-type').find('*').filter(':input:visible:first').val() == 'from_disk') {
      $('.cp-cta-link').hide()
      $('.cp-cta-link-data').hide()
    } else {
      $('.cp-cta-file').hide()
      $('.cp-cta-file-data').hide()
    }
  }
  $('form').on('click', '.remove_record', function (event) {
    $(this).prev('input[type=hidden]').val('1')
    $(this).closest('tr').hide()
    return event.preventDefault()
  })

  $('form').on('click', '.add_fields', function (event) {
    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    $('.fields').append($(this).data('fields').replace(regexp, time))
    return event.preventDefault()
  })

  $('#cp-type-list').change(function () {
    var type = $(this).val()
    if (type == 'reference') {
      $('.cp-add-cta').show()
      $('.cp-cta-icon').show()
      $('.cp-cta-icon-data').show()
      $('.cp-cta-link').show()
      $('.cp-cta-link-data').show()
    } else {
      $('.cp-add-cta').hide()
      $('.cp-cta-icon').hide()
      $('.cp-cta-icon-data').hide()
    }
  })

  $('.cp-cta-type').change(function () {
    if ($('#cp-type-list').val() != 'reference') {
      var type = $(this).find('*').filter(':input:visible:first').val()
      if (type == 'from_disk') {
        $('.cp-cta-link').hide()
        $('.cp-cta-link-data').hide()
        $('.cp-cta-file').show()
        $('.cp-cta-file-data').show()
      } else {
        $('.cp-cta-link').show()
        $('.cp-cta-link-data').show()
        $('.cp-cta-file').hide()
        $('.cp-cta-file-data').hide()
      }
    }
  })

  $('#cp-top-list-new').change(function () {
    var id = $(this).val()
    $.ajax({
      url: '/admin/cp_contents/fetch_second_level?cp_top_level_id=' + id,
      method: 'GET',
      dataType: 'json',
      error: function (xhr, status, error) {
        console.error('AJAX Error: ' + status + error)
      },
      success: function (response) {
        var data = response['cp_second_level_data']
        var cp_second_level = data[0]['id']
        var url = new URL(window.location)
        url.searchParams.set('cp_second_level_id', cp_second_level)
        url.searchParams.set('cp_top_level_id', id)
        window.location = url
      },
    })
  })

  $('#cp-top-list').change(function () {
    var id = $(this).val()

    $.ajax({
      url: '/admin/cp_contents/fetch_second_level?cp_top_level_id=' + id,
      method: 'GET',
      dataType: 'json',
      error: function (xhr, status, error) {
        console.error('AJAX Error: ' + status + error)
      },
      success: function (response) {
        var data = response['cp_second_level_data']
        $('#cp-second-list').empty()
        for (var i = 0; i < data.length; i++) {
          $('#cp-second-list').append(
            '<option value="' + data[i]['id'] + '">' + data[i]['title'] + '</option>',
          )
        }
      },
    })
  })
})
